import { decrypt, encrypt } from "../../utils/crypto";

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const setItemInSessionStorage = (key: string, value: any) => {
  const encryptedValue = encrypt(value);
  sessionStorage.setItem(key, encryptedValue);
};

export const getItemFromSessionStorage = (key: string) => {
  const encryptedValue = sessionStorage.getItem(key);
  return encryptedValue && encryptedValue !== null
    ? decrypt(encryptedValue)
    : null;
};

export const removeItemFromSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};

export const setItemInLocalStorage = (key: string, value: any) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error("Error setting local storage", error);
  }
};

export const getItemFromLocalStorage = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
};
